import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { placesCityQueryOptions } from "common/hooks/places/placesQueryOptions";
import type { PlacesCityParams } from "common/types/places";
import { PlacesListing } from "@/components/Places/PlacesListing";
import { PlacesUnavailable } from "@/components/Places/PlacesUnavailable";
import { buildPlacesCityHead, parsePlacesSearch } from "@/lib/placesPage";
import { loadPlacesPage } from "@/lib/placesPageLoader";

const isProduction =
  import.meta.env.VITE_APPLICATION_ENVIRONMENT === "Production";

export const Route = createFileRoute("/places/$citySlug")({
  ssr: true,
  component: PlacesCity,
  errorComponent: PlacesUnavailable,
  validateSearch: (search: Record<string, unknown>): PlacesCityParams => parsePlacesSearch(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, params, deps: { search } }) =>
    loadPlacesPage(context.queryClient, params.citySlug, [], search),
  head: ({ loaderData, params }) =>
    buildPlacesCityHead(
      loaderData?.page,
      params.citySlug,
      loaderData?.search ?? {},
      loaderData?.canonicalOrigin ?? "",
      isProduction,
    ),
});

function PlacesCity() {
  const { citySlug } = Route.useParams();
  const search = Route.useSearch();
  const { data } = useQuery(placesCityQueryOptions(citySlug, search));

  if (!data?.data) {
    return null;
  }

  return <PlacesListing data={data.data} citySlug={citySlug} search={search} />;
}
